(() => {
  const initialize = () => {
    document.querySelectorAll('[data-pp-header]').forEach(header => {
      if (header.dataset.enhanced) return;
      header.dataset.enhanced = 'true';
      const button = header.querySelector('.pp-header-menu-toggle');
      const menus = [...header.querySelectorAll('.pp-header-dropdown')];
      const groups = [...header.querySelectorAll('.pp-discover-group')];
      const desktop = window.matchMedia('(min-width:990px)');
      const setMobileOpen = open => {
        header.toggleAttribute('data-menu-open', open);
        button.setAttribute('aria-expanded', String(open));
      };
      const closeMenus = () => menus.forEach(menu => menu.open = false);
      const updateHeight = () => document.documentElement.style.setProperty('--pp-header-height', header.getBoundingClientRect().height + 'px');
      const updateMode = () => {
        groups.forEach(group => group.open = desktop.matches);
        setMobileOpen(false);
        closeMenus();
        updateHeight();
      };
      button.addEventListener('click', () => setMobileOpen(button.getAttribute('aria-expanded') !== 'true'));
      groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
        if (desktop.matches) event.preventDefault();
      }));
      menus.forEach(menu => menu.addEventListener('toggle', () => {
        if (!menu.open) return;
        menus.forEach(other => { if (other !== menu) other.open = false; });
        document.querySelectorAll('.ar-member-menu[open]').forEach(other => other.open = false);
      }));
      document.addEventListener('click', event => {
        if (!header.contains(event.target)) { closeMenus(); setMobileOpen(false); }
      });
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const active = menus.find(menu => menu.open);
        if (active) { active.open = false; active.querySelector('summary').focus(); }
        else if (header.hasAttribute('data-menu-open')) { setMobileOpen(false); button.focus(); }
      });
      desktop.addEventListener('change', updateMode);
      new ResizeObserver(updateHeight).observe(header);
      updateMode();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();